import { useContext, createContext } from 'react';

export const EPlatContext = createContext(null);

export function useEPlatContext() {
  return useContext(EPlatContext);
}
